module.exports = __webpack_public_path__ + "img/recent-work-01.6cdf58e4.jpg";